//
import Model from '@/models/Model'
import RepackingParentsModel from '@/models/Actions/ARepackingParents'

//
export default class WhItem extends Model {
    // the editable params
    //upc_codes = []
    //branch_office_selected = []

    /**
     * the dispatch batch model errors
     */
    static errors = {
        branch_office_data: {
            name: 'Detalle de stock',
            translates: [
                {
                    translate: ' branch office data ',
                    value: ' ',
                },
            ],
        },
        product_name: {
            name: 'Nombre',
            translates: [
                {
                    translate: ' product name ',
                    value: ' ',
                },
            ],
        },
        wh_subfamily_id: {
            name: 'Subfamilia',
            translates: [
                {
                    translate: ' wh subfamily id ',
                    value: ' ',
                },
            ],
        },
    }

    /**
     *
     */
    get suggest_internal_code_params() {
        return {
            family_id: Number(this.wh_family_id || 1),
            product_name: String(this.name || '').replace('#', '%23'),
            subfamily_id: Number(this.wh_subfamily_id || 1),
        }
    }

    //
    static includes = ['wh_warehouse_items']

    /**
     *
     */
    mapBranchOfficeData(item) {
        return {
            g_branch_office_id: Number(item.id),
            critical_stock: Number(item.critical_stock),
            maximum_stock: Number(item.maximum_stock),
            minimum_stock: Number(item.minimum_stock),
            cost_price: Number(0),
            sale_price: Number(0),
            gains_margin: Number(0),
        }
    }

    /**
     *
     */
    reset() {
        //
        this.internal_code = this.internal_code || ''
        this.upc_codes = this.upc_codes || []
        this.branch_office_selected = this.branch_office_selected || []

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'wh_item'
    }

    /**
     *
     */
    repackingParents() {
        return this.hasMany(RepackingParentsModel)
    }

    /**
     *
     */
    toCreate() {
        // set new data
        this.branch_office_data = this.branch_office_selected.map(
            this.mapBranchOfficeData
        )

        //
        if (this.branch_office_data.length < 1) {
            throw this.error('Se necesita de al menos una sucursal.')
        }

        // trim the required data to post request
        return this.clean([
            'alias_name',
            'branch_office_data',
            'description',
            'internal_code',
            'have_decimal_quantity',
            'is_inventoriable',
            'is_repackaged',
            'name',
            'tags',
            'uom_quantity',
            'upc_codes',
            'warranty_days',
            'wh_family_id',
            'wh_subfamily_id',
            'wh_unit_of_measurement_id',
        ])
    }

    toCreate2() {
        return this.clean([
            'alias_name',
            'description',
            'internal_code',
            'name',
            'tags',
            'upc_codes',
            'wh_family_id',
            'wh_subfamily_id',
        ])
    }

    /**
     *
     */
    toUpdate() {
        // set new data
        this.branch_office_data = this.branch_office_selected.map(
            this.mapBranchOfficeData
        )

        //
        this.id = this.wh_item_id || this.id

        // trim the required data to post request
        return this.clean([
            'alias_name',
            'branch_office_data',
            'description',
            'id',
            'internal_code',
            'have_decimal_quantity',
            'is_inventoriable',
            'is_repackaged',
            'name',
            'tags',
            'uom_quantity',
            'upc_codes',
            'warranty_days',
            'wh_family_id',
            'wh_subfamily_id',
            'wh_unit_of_measurement_id',
        ])
    }
}
